import { createContext, useContext, useState, useCallback, useRef } from "react";
import api from "../api";

const DataCacheContext = createContext(null);

export const DataCacheProvider = ({ children }) => {
  const cache = useRef({}); // { [cacheKey]: { data, total, timestamp } }
  console.log("Cache Provider Mounted");

  // Check if cache is still fresh (default 5 minutes)
  const isFresh = useCallback((cacheKey, ttl = 5 * 60 * 1000) => {
    const entry = cache.current[cacheKey];
    if (!entry) return false;
    return Date.now() - entry.timestamp < ttl;
  }, []);

  // Read from cache
  const getCache = useCallback((cacheKey) => {
    return cache.current[cacheKey] || null;
  }, []);

  // Write to cache
  const setCache = useCallback((cacheKey, data) => {
    cache.current[cacheKey] = {
      ...data,
      timestamp: Date.now(),
    };
  }, []);

  // Invalidate one key or all keys with a prefix
  const invalidate = useCallback((cacheKey) => {
    if (cacheKey) {
      // Invalidate all keys that start with this prefix
      // e.g. invalidate("users") clears "users:active:latest" etc.
      Object.keys(cache.current).forEach((key) => {
        if (key.startsWith(cacheKey)) {
          delete cache.current[key];
        }
      });
    } else {
      cache.current = {}; // clear everything
    }
  }, []);

  return (
    <DataCacheContext.Provider value={{ isFresh, getCache, setCache, invalidate }}>
      {children}
    </DataCacheContext.Provider>
  );
};

export const useDataCache = () => useContext(DataCacheContext);